export const MOBILE_ACTION_KEYS = {
  GO_BACK: 'GO_BACK',
  NEW_REFERRAL_APPT: 'NEW_REFERRAL_APPT',
}